export class ValidationError extends Error {
	constructor(message?: string, cause?: unknown) {
		const options: ErrorOptions = {
			cause: cause,
		};

		super(message, options);
	}
}
